

import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Header from "./Header";

import "./ManageRooms.css";
import { Modal, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import host from "../config";
const ManageRooms = () => {
  // let host = "https://api.vmrdarental.com";
  // let host = "https://api.vmrdarental.com";
  const navigate = useNavigate();
  const [roomData, setRoomData] = useState([]);
  const [statusCheck, setStatusCheck] = useState(false);
  const [isShow, invokeModal] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteRoom, setDeleteRoom] = useState({ room_id: null, purposes: [] });
  const [selectedPurposes, setSelectedPurposes] = useState([]);

  const [editableRoom, setEditableRoom] = React.useState({});
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    navigate("/", "_self");
  }
  if (localStorage.getItem("userRole") != 1) {
    navigate("/", "_self");
  }
  const initModal = () => {
    return invokeModal(!false);
  };
  const closeInitModal = () => {
    return invokeModal(false);
  };
  const openDeleteModal = (room) => {
    setDeleteRoom(room);
    setSelectedPurposes(room.purposes); // Default all purposes selected
    setShowDeleteModal(true);
  };
  const togglePurposeSelection = (purpose) => {
    setSelectedPurposes(
      (prev) =>
        prev.includes(purpose)
          ? prev.filter((p) => p !== purpose) // Remove if already selected
          : [...prev, purpose] // Add if not selected
    );
  };

  const confirmDelete = () => {
    if (selectedPurposes.length === 0) {
      alert("Please select at least one purpose to delete.");
      return;
    }

    let payload = {
      roomId: deleteRoom.room_id,
      purposes: selectedPurposes, // Only delete selected purposes
    };

    fetch(host + "/delete-room-details", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).then((response) => {
      response.json().then((res) => {
        alert(res.message);
        setShowDeleteModal(false);
        getRoomsMaster(); // Refresh rooms
      });
    });
  };

  const getRoomsMaster = () => {
    fetch(
      `${host}/get-rooms?location=${document.getElementById("locationIds").value}&time=${Math.round(new Date().getTime() / 1000)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((rooms) => {
        setRoomData(rooms); // Updated room data with purposes
      })
      .catch((error) => console.error("Error fetching rooms:", error));
  };

  const updateRoomStatus = (e, roomId) => {
    let updateRequest = {};
    updateRequest.locationId = document.getElementById("locationIds").value;
    updateRequest.roomId = roomId;
    updateRequest.status = e.target.checked;
    fetch(host + "/update-room-status", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updateRequest),
    }).then((response) => {
      alert(response.json());
      getRoomsMaster();
    });
  };

  const editRoomDetails = (roomId) => {
    const roomToEdit = roomData.find((room) => room.room_id === roomId);

    if (roomToEdit) {
      setEditableRoom({
        ...roomToEdit,
        amounts: { ...roomToEdit.amounts }, // Store amounts for editing
      });
      setStatusCheck(roomToEdit.status);
    }
  };

  const updateRoomDetails = () => {
    let payload = {
      roomId: editableRoom.room_id,
      amounts: {},
    };

    let hasUpdates = false;

    // Capture Updated Amounts for Each Purpose
    editableRoom.purposes.forEach((purpose) => {
      let updatedAmount = {};

      const rentInput = document.getElementById(`rent-${purpose}`);
      const gstInput = document.getElementById(`gst-${purpose}`);
      const depositInput = document.getElementById(`deposit-${purpose}`);

      let rent = rentInput?.value ? Number(rentInput.value) : null;
      let gst = gstInput?.value ? Number(gstInput.value) : null;
      let deposit = depositInput?.value ? Number(depositInput.value) : null;

      updatedAmount.rent = rent !== null ? rent : 0;
      updatedAmount.gst = gst !== null ? gst : 0;
      updatedAmount.security_deposit = deposit !== null ? deposit : 0;

      hasUpdates = true;

      payload.amounts[purpose] = updatedAmount;
    });

    if (!hasUpdates) {
      alert("No changes detected!");
      return;
    }

    // Send Updated Fields Only
    fetch(host + "/update-room-amounts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("access_token"),
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((res) => {
        alert(res.message);
        getRoomsMaster(); // Refresh the room list to reflect changes
        closeInitModal();
      })
      .catch((error) => console.error("Error updating room amounts:", error));
  };

  const deleteRoomDetails = (roomId) => {
    let payload = JSON.parse("{}");
    if (roomId !== undefined) {
      payload.roomId = roomId;
    } else {
      alert("Unable to process your request");
      return;
    }

    fetch(host + "/delete-room-details", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }).then((response) => {
      response.json().then((res) => {
        alert(res.message);
      });
      getRoomsMaster();
    });
  };

  useEffect(() => {
    getRoomsMaster();
  }, []);

  return (
    <div>
      <Header />
      {/* <Navbar /> */}
      <div className="container">
        <div className="row">
          {/* <div className="col-lg-2"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
            <div className="row">
              <div style={{ width: "20%" }}>
                <b>Select Location</b>
                <select
                  id="locationIds"
                  onChange={() => {
                    getRoomsMaster();
                  }}
                >
                  <option value="1">Gurajada Kalakshetram</option>
                  <option value="2">MGM LAWN</option>
                  <option value="3">Chinnamusidivada</option>
                  <option value="4">Childrens Arena</option>
                </select>
              </div>
              <div style={{ width: "30%" }}></div>
              <div style={{ width: "50%" }}>
                {/* <button
                  className="booking_buttons float_right"
                  onClick={() => initModal()}
                >
                  Add Room
                </button> */}
              </div>
            </div>
            <div className="row">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Accommodation Type</th>
                      <th>Venue Name</th>
                      <th>Purposes</th>
                      <th>Amount (Rent + GST + Deposit)</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {/* <tbody>
                    {roomData.map((room, i) => (
                      <tr key={room.room_id}>
                        <td>{room.accommodation_type}</td>
                        <td>{room.room_name}</td>
                        <td>
                          {room.purposes.map((purpose) => (
                            <div key={purpose}>
                              <strong>{purpose}</strong>: ₹
                              {room.amounts[purpose].price}
                            </div>
                          ))}
                        </td>
                        <td>
                          {room.purposes.map((purpose) => (
                            <div key={purpose}>
                              Rent: ₹{room.amounts[purpose].rent}, GST: ₹
                              {room.amounts[purpose].gst}, Deposit: ₹
                              {room.amounts[purpose].security_deposit}
                            </div>
                          ))}
                        </td>
                        <td>{room.status ? "Active" : "Inactive"}</td>
                        <td>
                          <i
                            className="fas fa-edit"
                            onClick={() => {
                              initModal();
                              editRoomDetails(room.room_id);
                            }}
                          ></i>{" "}
                         
                          <i
                            className="fas fa-trash"
                            onClick={() => openDeleteModal(room)}
                          ></i>
                        </td>
                      </tr>
                    ))}
                  </tbody> */}

                  <tbody>
                    {roomData.map((room) => (
                      <tr key={room.room_id}>
                        <td>{room.accommodation_type}</td>
                        <td>{room.room_name}</td>

                        {/* Purposes */}
                        <td>
                          <table className="table table-borderless">
                            <tbody>
                              {room.purposes.map((purpose, index) => (
                                <tr key={index}>
                                  <td>
                                    <strong>{purpose}</strong>: ₹
                                    {room.amounts[purpose].price}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>

                        {/* Amounts */}
                        <td>
                          <table className="table table-borderless">
                            <tbody>
                              {room.purposes.map((purpose, index) => (
                                <tr key={index}>
                                  <td>
                                    Rent: ₹{room.amounts[purpose].rent}, GST: ₹
                                    {room.amounts[purpose].gst}, Deposit: ₹
                                    {room.amounts[purpose].security_deposit}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>

                        <td>{room.status ? "Active" : "Inactive"}</td>

                        <td>
                          <i
                            className="fas fa-edit"
                            onClick={() => {
                              initModal();
                              editRoomDetails(room.room_id);
                            }}
                          ></i>{" "}
                          <i
                            className="fas fa-trash"
                            onClick={() => openDeleteModal(room)}
                          ></i>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={isShow} onHide={closeInitModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Room Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editableRoom.purposes?.map((purpose) => (
            <div key={purpose} className="mb-3">
              <h6>{purpose}</h6>
              <label>Rent:</label>
              <input
                type="number"
                id={`rent-${purpose}`}
                defaultValue={editableRoom.amounts[purpose]?.rent || 0}
                className="form-control"
              />

              <label>GST:</label>
              <input
                type="number"
                id={`gst-${purpose}`}
                defaultValue={editableRoom.amounts[purpose]?.gst || 0}
                className="form-control"
              />

              <label>Deposit:</label>
              <input
                type="number"
                id={`deposit-${purpose}`}
                defaultValue={
                  editableRoom.amounts[purpose]?.security_deposit || 0
                }
                className="form-control"
              />
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeInitModal}>
            Close
          </Button>
          <Button variant="primary" onClick={updateRoomDetails}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>
          <p>Room ID: {deleteRoom.room_id}</p>
          <p>Select purposes to delete:</p>
          {deleteRoom.purposes?.map((purpose, index) => (
            <div key={index}>
              <input
                type="checkbox"
                checked={selectedPurposes.includes(purpose)}
                onChange={() => togglePurposeSelection(purpose)}
              />
              {purpose}
            </div>
          ))}
        </Modal.Body> */}
        <Modal.Body>
          <p style={{ textAlign: "center", marginBottom: "10px" }}>
            Select purposes to delete:
          </p>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              padding: "10px",
            }}
          >
            {deleteRoom.purposes?.map((purpose, index) => (
              <label
                key={index}
                style={{
                  display: "flex",
                  alignItems: "start",
                  gap: "10px",
                  lineHeight: "1.4",
                  maxWidth: "100%",
                  wordBreak: "break-word",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedPurposes.includes(purpose)}
                  onChange={() => togglePurposeSelection(purpose)}
                  style={{
                    transform: "scale(1.2)",
                    marginTop: "3px",
                    cursor: "pointer",
                  }}
                />
                <span style={{ display: "block", flex: "1" }}>{purpose}</span>
              </label>
            ))}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Confirm Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManageRooms;
